/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedMeasurementUnitProvider_user$ref = any;
type TradeRewardsMessagingWrapper_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespSearchResultContainer_user$ref: FragmentReference;
export type SbRespSearchResultContainer_user = {|
  +serviceId: ?string,
  +tradeFirm?: ?{|
    +serviceId: ?string
  |},
  +$fragmentRefs: SbSharedMeasurementUnitProvider_user$ref & TradeRewardsMessagingWrapper_user$ref,
  +$refType: SbRespSearchResultContainer_user$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SbRespSearchResultContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "FragmentSpread",
      "name": "SbSharedMeasurementUnitProvider_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeRewardsMessagingWrapper_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeFirm",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '2806b0124c16051a76b1ead8e146469b';
module.exports = node;
